module.exports = __webpack_public_path__ + "img/Q2.1208a6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/Q2.png
// module id = QJwy
// module chunks = 0